(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discount-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Discount config: code → { collectionId the discount targets, percent off }
    // collectionId is the numeric Shopify collection id (the discount applies to
    // any product belonging to this collection).
    var KG_CODES = {
      HIMALAYA: { collectionId: '447086952692', percent: 10 }
    };
    var STORE_KEY = 'kg_pending_discount';
    var DISMISS_KEY = 'kg_discount_dismissed_until';
    var DISMISS_MS = 24 * 60 * 60 * 1000;
    // Fallback safety net: if the Web Pixel cleanup misses (different device,
    // network error, no consent), entries auto-expire after 14 days.
    var EXPIRY_MS = 14 * 24 * 60 * 60 * 1000;

    function readEntry() {
      try {
        var raw = localStorage.getItem(STORE_KEY);
        if (!raw) return null;
        var data;
        try {
          data = JSON.parse(raw);
        } catch (e) {
          // Legacy plain-string format → migrate to JSON with current timestamp
          data = { code: String(raw).toUpperCase(), saved_at: Date.now() };
          localStorage.setItem(STORE_KEY, JSON.stringify(data));
        }
        if (!data || typeof data !== 'object' || !data.code) return null;
        // Expiry check
        if (typeof data.saved_at !== 'number' || Date.now() - data.saved_at > EXPIRY_MS) {
          localStorage.removeItem(STORE_KEY);
          return null;
        }
        return data;
      } catch (e) { return null; }
    }

    function writeEntry(code) {
      try {
        localStorage.setItem(STORE_KEY, JSON.stringify({
          code: code,
          saved_at: Date.now()
        }));
      } catch (e) {}
    }

    function captureFromUrl() {
      var pathMatch = location.pathname.match(/^\/discount\/([^/?#]+)/i);
      var qs;
      try { qs = new URLSearchParams(location.search); } catch (e) { qs = null; }
      var queryCode = qs ? qs.get('discount') : null;
      var found = (pathMatch && pathMatch[1]) || queryCode || '';
      var upper = found.toUpperCase();
      if (upper && KG_CODES[upper]) {
        writeEntry(upper);
      }
    }

    function activeCode() {
      var entry = readEntry();
      if (!entry) return null;
      var code = String(entry.code || '').toUpperCase();
      return KG_CODES[code] ? code : null;
    }

    function shouldShow() {
      if (!activeCode()) return false;
      try {
        var dismissedUntil = parseInt(localStorage.getItem(DISMISS_KEY) || '0', 10);
        return Date.now() >= dismissedUntil;
      } catch (e) { return true; }
    }

    function formatYen(cents) {
      var yen = Math.round(cents / 100);
      return '¥' + yen.toLocaleString('ja-JP');
    }

    function applyDiscountToProducts() {
      var code = activeCode();
      if (!code) return;
      var cfg = KG_CODES[code];

      var containers = document.querySelectorAll('[data-kg-product-collections]');
      containers.forEach(function (c) {
        if (c.dataset.kgDiscountApplied === '1') return;
        var collIds = (c.getAttribute('data-kg-product-collections') || '').split(',').map(function (s) { return s.trim(); });
        if (collIds.indexOf(cfg.collectionId) === -1) return;

        var priceCents = parseInt(c.getAttribute('data-kg-product-price') || '0', 10);
        if (!priceCents) return;
        var discountedCents = Math.round(priceCents * (100 - cfg.percent) / 100);

        var priceItems = c.querySelectorAll('.price-item--regular');
        priceItems.forEach(function (el) {
          var original = el.textContent.trim();
          if (!original) return;
          el.innerHTML = '<s class="kg-price-strike">' + original + '</s>' +
            '<span class="kg-price-final">' + formatYen(discountedCents) + '</span>';
        });
        c.dataset.kgDiscountApplied = '1';
      });
    }

    function revertDiscountFromProducts() {
      var containers = document.querySelectorAll('[data-kg-product-collections][data-kg-discount-applied="1"]');
      containers.forEach(function (c) {
        var priceCents = parseInt(c.getAttribute('data-kg-product-price') || '0', 10);
        if (!priceCents) return;
        var priceItems = c.querySelectorAll('.price-item--regular');
        priceItems.forEach(function (el) {
          el.textContent = formatYen(priceCents);
        });
        delete c.dataset.kgDiscountApplied;
      });
    }

    function render() {
      var banners = document.querySelectorAll('.kg-discount-banner');
      var visible = shouldShow();
      banners.forEach(function (el) {
        if (visible) {
          el.removeAttribute('hidden');
          el.classList.add('is-visible');
          var pos = el.getAttribute('data-kg-position') || 'below';
          document.body.classList.add('kg-discount-active');
          document.body.classList.add('kg-discount-active-' + pos);
          if (pos === 'above') {
            // Reserve space at top of body so content isn't hidden under the fixed banner
            var h = el.getBoundingClientRect().height;
            if (h > 0) document.body.style.paddingTop = h + 'px';
          }
        } else {
          el.setAttribute('hidden', '');
          el.classList.remove('is-visible');
        }
      });

      // Price strike-through (PDP + collection cards) is independent of banner
      // dismissal — a customer with a pending discount should still see the
      // discounted price even after closing the banner.
      if (activeCode()) {
        applyDiscountToProducts();
      } else {
        revertDiscountFromProducts();
      }
    }

    function dismiss() {
      var until = Date.now() + DISMISS_MS;
      try { localStorage.setItem(DISMISS_KEY, String(until)); } catch (e) {}
      document.querySelectorAll('.kg-discount-banner').forEach(function (el) {
        el.setAttribute('hidden', '');
        el.classList.remove('is-visible');
      });
      ['', '-above', '-below', '-replace'].forEach(function (suffix) {
        document.body.classList.remove('kg-discount-active' + suffix);
      });
      document.body.style.paddingTop = '';
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('.kg-discount-banner__dismiss')) dismiss();
    });

    captureFromUrl();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', render);
    } else {
      render();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
